class FeaturedCollections extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector(
      '[data-el="featured-collections.slides"]'
    )
    this.slideEls = this.querySelectorAll(
      '[data-el="featured-collections.slide"]'
    )
    this.controlPrevEl = this.querySelector(
      '[data-el="featured-collections.controlprevious"]'
    )
    this.controlNextEl = this.querySelector(
      '[data-el="featured-collections.controlnext"]'
    )
    this.scrollerEl = this.querySelector(
      '[data-el="featured-collections.scroller"]'
    )

    if (this.slideEls.length < 2) return

    this.carousel = this.initialiseCarousel()

    if (this.controlPrevEl) {
      this.controlPrevEl.addEventListener('click', this.onNavClick.bind(this))
    }

    if (this.controlNextEl) {
      this.controlNextEl.addEventListener('click', this.onNavClick.bind(this))
    }
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    return new window.KeenSlider551(this.slidesEl, {
      slides: '.car-Carousel_Slide',
      slidesPerView: 1.25,
      spacing: 0,
      rubberband: false,
      breakpoints: {
        '(min-width: 600px)': {
          slidesPerView: 2,
          spacing: 0
        },
        '(min-width: 768px)': {
          slidesPerView: 2.4,
          spacing: 0
        },
        '(min-width: 901px)': {
          slidesPerView: 3,
          spacing: 0
        },
        '(min-width: 1201px)': {
          slidesPerView: 3.4,
          spacing: 0
        }
      },
      created: () => {
        this.slidesEl.classList.remove('car-Carousel_Slides-hidden')
      },
      slideChanged: instance => {
        const maxClicks =
          instance.details().size - instance.details().slidesPerView

        if (this.controlPrevEl) {
          instance.details().relativeSlide === 0
            ? (this.controlPrevEl.disabled = true)
            : (this.controlPrevEl.disabled = false)
        }
        if (this.controlNextEl) {
          instance.details().relativeSlide >= maxClicks
            ? (this.controlNextEl.disabled = true)
            : (this.controlNextEl.disabled = false)
        }
      },
      move: instance => {
        if (this.scrollerEl) {
          let progressTrack = instance.details().progressTrack
          progressTrack = progressTrack >= 1 ? 0 : progressTrack
          const movementPercentage = progressTrack * 100
          this.scrollerEl.style.setProperty(
            '--movement',
            `${movementPercentage}%`
          )
        }
      }
    })
  }

  onNavClick (event) {
    if (event.currentTarget.dataset.direction === 'previous') {
      this.carousel.prev()
    } else {
      this.carousel.next()
    }
  }
}

customElements.define('featured-collections', FeaturedCollections)
